import { Visit } from '@/pages/types';
import { ProseDisplay } from '@/components/Tiptap';
import { Rating } from '@/trailmix/Rating';
import { cn } from '@/trailmix/lib/cn';
import { getImageFromCDN } from '@/image-cdn';
import { getDateTimeStringForDisplay } from '@/datetime/utils';
import { PhotoGrid } from '@/trailmix/PhotoGrid';

type VisitInfoProps = {
    visit: Visit;
    className?: string;
};

export function VisitInfoCard({ visit, className }: VisitInfoProps) {
    return (
        <div className={cn('flex flex-col gap-4', className)}>
            {(visit.visit_date !== null || visit.rating !== null) && (
                <div className='flex flex-col gap-2'>
                    {visit.visit_date !== null && (
                        <p className='font-semibold text-gray-700'>
                            Visited on{' '}
                            {getDateTimeStringForDisplay({ dateISO: visit.visit_date, timeISO: visit.visit_time })}
                        </p>
                    )}

                    {visit.rating && (
                        <div className={cn(!visit.visit_date && 'mt-0.5')}>
                            <Rating value={visit.rating} />
                        </div>
                    )}
                </div>
            )}

            {visit.notes && <ProseDisplay content={visit.notes} />}

            {visit.photos.length > 0 && (
                <PhotoGrid
                    photos={visit.photos.map(photo => ({
                        id: photo.id,
                        originalURL: getImageFromCDN({ path: photo.path, size: 'original' }).toURL(),
                        thumbnailURL: getImageFromCDN({ path: photo.path, size: 'medium' }).toURL(),
                    }))}
                />
            )}
        </div>
    );
}
